import * as React from 'react'
import { TaskDescriptionMainConnected } from './TaskDescriptionMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TaskDescriptionMainExamples = () => {
  return (
    <div className="TaskDescriptionMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskDescriptionMainConnected />
      </Provider>
    </div>
  )
}
